import {
	isConfluenceCreatableAction,
	isConfluenceUpdatableAction,
} from '@atlassian/conversation-assistant-action-helpers/utils/confluence-actions';
import { CONFLUENCE_PAGE_CREATE_KEY } from '@atlassian/conversation-assistant-message-actions-api/constants';
import { type StoreChatItem } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { getLastAssistantActions } from './getLastAssistantActions';

export function lastAssistantHasConfluencePageAction(messages: StoreChatItem[]): boolean {
	return getLastAssistantActions(messages).some(
		(action) =>
			isConfluenceCreatableAction({ key: action.key }) ||
			isConfluenceUpdatableAction({ key: action.key }) ||
			action.key === CONFLUENCE_PAGE_CREATE_KEY,
	);
}
